import { X } from 'lucide-react'
import { useTranslation } from '@kostbar/i18n'
import { Input } from '@/components/ui/input'

type TextFilterProps = {
  value?: string
  placeholder?: string
  onChange: (value: string | undefined) => void
}

export function TextFilter({ value, placeholder, onChange }: TextFilterProps) {
  const { t: tUi } = useTranslation('ui')
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Clear filter on Escape key
    if (e.key === 'Escape' && value) {
      e.preventDefault()
      onChange(undefined)
    }
  }

  return (
    <div className="flex items-center gap-2">
      <Input
        value={value ?? ''}
        placeholder={placeholder}
        className="w-[220px]"
        onChange={(e) => onChange(e.target.value || undefined)}
        onKeyDown={handleKeyDown}
      />
      {value ? (
        <button
          type="button"
          aria-label={tUi('filters.clearFilter')}
          className="text-muted-foreground hover:text-foreground"
          onClick={() => onChange(undefined)}
        >
          <X className="w-4 h-4" />
        </button>
      ) : null}
    </div>
  )
}
